module.exports = __webpack_public_path__ + "media/images/favicons/site-tile-150x150-754a3c75372bf6ec588f452fd885d2bc.png";